import React, { useState, useContext, useEffect } from "react";
import styled, { css } from 'styled-components';

import {
  CssTableLine,
  CssSwitchSub,
  CssTableCountry,
  CssTableFlag,
  CssTableDays,
  CssInputDay,
  SelectSquare,
  PAinfoCollapsible
} from "./../uikit2";

import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  Collapse,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import { gcCountries, currencies } from '../../data';
import { PAgcGKcountryLine } from "./PAgcGKcountryLine";
import { Reset } from "./Reset";






export const PAgcGKprices = ({}) => {
  const [opened, setOpened] = useState(false);

  const [defPrice, setDefPrice] = useState(199);

  const [defCurr, setDefCurr] = useState(Object.keys(currencies)[0]);

  const getCurrs = () => {
    return Object.keys(currencies).map((oneCurrName, ind)=>({
        label: <CssSelectItem><CssTableCurr>{currencies[oneCurrName]['symbol']}</CssTableCurr>{currencies[oneCurrName]['name']}</CssSelectItem>,
        // label: currencies[oneCurrName]['name'],
        value: oneCurrName,
      }))
  }

  return (
    <FormGroup label="">
      <FormGroup label="Default price and currency">
        <div style={{ display: "flex" }}>
          <div
            style={{
              flexGrow: 0,
              flexBasis: "33%"
            }}
            // className={!currLocked ? 'xsui-price-input-center' : ''}
          >
            <Select
              // disabled={this.disabled}
              name=""
              options={getCurrs()}
              searchable={false}
              autosize={false}
              dock={"right"}
              size={"md"}
              input={{
                onChange: setDefCurr,
                value: defCurr
              }}
            />
          </div>

          <Input
            style={{
              flexGrow: 1,
              flexBasis: "33%",
              width: 64
            }}
            dock={"left"}
            key="1"
            size="md"
            input={{
              name: "1",
              value: defPrice,
              // onFocus: handleFocus,
              onChange: (e: SyntheticInputEvent<HTMLInputElement>) => {
                let val = e.target.value
                setDefPrice(val);
              }
            }}
          />
        </div>
      </FormGroup>

      <FormGroup label="Settings by currency">
        <PAinfoCollapsible
          isOpen={opened}
          handleChange={newOpen => {
            setOpened(newOpen);
          }}
          title={() => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "stretch",
                  alignItems: "center",
                  position: "relative",
                  // marginTop: '-8px',
                  height: "24px",
                  width: "100%"
                }}
              >
                <div
                  style={{ flexGrow: 1, display: "flex", overflow: "hidden" }}
                >
                 {currencies[defCurr]['name']}: {currencies[defCurr]['symbol']}&thinsp;{defPrice},&nbsp;
                 EUR: €&thinsp;{parseFloat(defPrice * 0.91).toFixed(2)},
                  ...
                </div>
              </div>
            );
          }}
          indentation="xs"
        >
          {opened && (
            <div
              style={{
                padding: "8px 16px",
                display: "flex",
                justifyContent: "space-between",
                width: "100%"
              }}
            >
              <UploadCsv />

              <Reset
                labels={[
                  {
                    title: `Reset all to recommended`,
                    description:
                      "The recommended price is calculated according to a median game price countries."
                  }
                ]}
                // handleChange ={(newch)=>{
                // }}
              />
            </div>
          )}

          {Object.keys(currencies).map((oneCurrName, ind) => {
            let oneCurr = currencies[oneCurrName];
            return (
              <PAgcGKcountryLine
                defCurr = {defCurr}
                defPrice = {defPrice}
                key={ind}
                ind={16}
                cur="min"
                oneCurr={oneCurr}
                handleChange={newCur => {
                  // setCur(newCur);
                }}
              />
            );
          })}
        </PAinfoCollapsible>
      </FormGroup>
    </FormGroup>
  );
};




export const UploadCsv = () => {
  return (
    <div
      className="xsui-form-group__label"
      style={
        {
          // position: "absolute",
          // right: 0,
          // bottom: 0
        }
      }
    >
      <Button type="button" icon={"upload"} appearance="flatten">
        Upload CSV
      </Button>
      &nbsp;&nbsp;
      {/* <Tooltip
                distance={12}
                label="Upload .CSV file. The file must contain these fields in the following order: platform, currency, price"
              /> */}
      <Dropdown
        align="left"
        size="sm"
        autosize={"md"}
        options={[
          {
            label: "Upload .CSV or .TXT file.",
            description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`
          },
          {
            onClick: () => {
              void 0;
            },
            value: "downloadExample",
            label: "Download example file",
            // description: `56 keys will be sent to your email after deletion`,
            icon: "download"
          }
          // {label: 'Update', description: 'Update this item', icon: 'update'}
        ]}
      >
        <Button
          style={{
            marginLeft: "4px"
          }}
          type="button"
          size="sm"
          appearance="flatten"
        >
          <div
            style={{
              height: 20,
              width: 20,
              borderRadius: 100,
              margin: "0 0px 6px 0",
              display: "grid",
              placeContent: "center center",
              // backgroundColor: "#ccc",
              border: "1px solid #0073f7"
            }}
          >
            <Icon
              // onClick={e => {
              //   this.handlePlatform(onePlatfIndex, "added");
              // }}
              name="question"
            />
          </div>
        </Button>
      </Dropdown>
    </div>
  );
};




const CssTableCurr = styled.span`
  font-size: 0.8em;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  font-weight: bolder;
  margin-right: 12px;
  min-width: 40px;
  min-height: 22px;
  align-items: center;
  top: 2px;
  left: 2px;
  text-align: center;
  background-color: #f2f3f7;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  z-index: 1;
  margin-left: -2px;
  margin-bottom: -10px;
  margin-top: -10px;
`

const CssSelectItem = styled.span`
  display: flex;
  align-items: center;
`